import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
  Layout,
  Card,
  Icon,
  TextStyle,
  Caption,
  PageActions,
  Link,
} from '@shopify/polaris';
import Navigation from './navigation';
import Header from './header';
import OrganizationCard from './organizationCard';
import {previousStep} from '../../actions/steps';
import {submitBrief} from '../../actions/progress';
import {generateBrief} from './helpers/brief';
import {MobilePadding} from 'components/polaris/react/mobile-padding';

class Summary extends React.Component {
  constructor(props) {
    super(props);

    this.renderDefaultSummary = this.renderDefaultSummary.bind(this);
    this.renderDefaultSummaryContent = this.renderDefaultSummaryContent.bind(
      this
    );
    this.renderPageActions = this.renderPageActions.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  render() {
    const {organization} = this.props;

    return (
      <Layout.Section>
        <Header />
        {organization && renderOrganizationCard()}
        {renderNavigation()}
        {organization
          ? renderDirectMatchSummary(organization)
          : this.renderDefaultSummary()}
        {this.renderPageActions()}
      </Layout.Section>
    );
  }

  renderDefaultSummary() {
    const title = 'Confirm and send';
    const description =
      'If you’re satisfied with the job details you provided, send the job for matching.';
    return (
      <Layout.AnnotatedSection title={title} description={description}>
        {this.renderDefaultSummaryContent()}
        {renderLegal()}
      </Layout.AnnotatedSection>
    );
  }

  renderDefaultSummaryContent() {
    const {services, serviceHandle} = this.props;

    return (
      <Layout.Section>
        <Card title="When you send your job for matching:">
          <Card.Section>
            <div className="stack-fill stack-fill--center">
              <Icon color="inkLightest" source="arrowRight" />
              <TextStyle>
                Your job <strong>{services[serviceHandle].label}</strong> will
                be matched {''}
                with experts best suited to meet your needs.
              </TextStyle>
            </div>
            <div className="stack-fill stack-fill--center">
              <Icon color="inkLightest" source="arrowRight" />
              <TextStyle>
                The matched experts will review your job and contact you {''}
                to discuss details and next steps.
              </TextStyle>
            </div>
            <div className="stack-fill stack-fill--center">
              <Icon color="inkLightest" source="arrowRight" />
              <TextStyle>
                You’re not committed to anything at this point. You can {''}
                choose to work with one of the matched experts or close the job.
              </TextStyle>
            </div>
          </Card.Section>
        </Card>
      </Layout.Section>
    );
  }

  renderPageActions() {
    return (
      <Layout.Section>
        <PageActions
          primaryAction={{
            content: 'Send job',
            onClick: this.handleSubmit,
          }}
          secondaryActions={[
            {
              content: 'Back',
              onClick: this.props.previousStep,
            },
          ]}
        />
      </Layout.Section>
    );
  }

  handleSubmit() {
    const {summary, files, organization, serviceHandle} = this.props;
    this.props.submitBrief(
      generateBrief(summary, files, organization, serviceHandle)
    );
  }
}

function renderOrganizationCard() {
  return (
    <Layout.Section>
      <OrganizationCard />
    </Layout.Section>
  );
}

function renderNavigation() {
  return (
    <Layout.Section>
      <Navigation />
    </Layout.Section>
  );
}

function renderDirectMatchSummary(organization) {
  const title = 'Confirm and send';
  const description =
    'If you’re satisfied with the job details you provided, send the job for review.';
  return (
    <Layout.AnnotatedSection title={title} description={description}>
      {renderDirectMatchSummaryContent(organization)}
      {renderLegal()}
    </Layout.AnnotatedSection>
  );
}

function renderDirectMatchSummaryContent(organization) {
  const title = `Send your job to ${organization.businessName} for review`;

  return (
    <Layout.Section>
      <Card title={title}>
        <Card.Section>
          <div className="stack-fill stack-fill--center">
            <TextStyle>
              If they’re available to do the work, they’ll contact you {''}
              to discuss next steps and details about job scope and price.
            </TextStyle>
          </div>
          <div className="stack-fill stack-fill--center">
            <TextStyle>
              You’re not committed to anything at this point. You can {''}
              choose to work with {organization.businessName} or close the job.
            </TextStyle>
          </div>
        </Card.Section>
      </Card>
    </Layout.Section>
  );
}

function renderLegal() {
  return (
    <Layout.Section>
      <MobilePadding>
        <Caption>
          By clicking Send job, you agree to the{' '}
          <Link url="https://www.shopify.com/legal/terms" external>
            Experts Marketplace Terms of Service
          </Link>
          .
        </Caption>
      </MobilePadding>
    </Layout.Section>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    submitBrief: brief => {
      return dispatch(submitBrief(brief));
    },

    previousStep: () => {
      return dispatch(previousStep());
    },
  };
}

function mapStateToProps(store) {
  const {
    context: {organization, files, serviceHandle},
    entities: {services},
  } = store;

  return {
    organization,
    files,
    services,
    serviceHandle,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Summary);

Summary.propTypes = {
  summary: PropTypes.arrayOf(PropTypes.object.isRequired),
  previousStep: PropTypes.func.isRequired,
  submitBrief: PropTypes.func.isRequired,
  organization: PropTypes.object,
  serviceHandle: PropTypes.string.isRequired,
  files: PropTypes.object.isRequired,
  services: PropTypes.object,
};
